<template>
  <v-progress-circular
    :rotate="360"
    :size="$vuetify.breakpoint.xs ? 45 : 55"
    :width="3"
    :value="value"
    :color="color"
  >
    <v-container fluid>
      <v-row no-gutters class="text-center">
        <v-col cols="12">
          <p class="text-h6 pa-0 ma-0" v-text="minutesShow" />
          <p class="text-caption pa-0 ma-0" v-text="'min'" />
        </v-col>
      </v-row>
    </v-container>
  </v-progress-circular>
</template>

<script>
export default {
  name: "TimeLeftCounter",
  props: {
    timeReady: {
      type: String,
      required: true,
    },
    totalMinutes: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    interval: {},
    value: 100,
    color: "green",
    minutesShow: null,
  }),
  watch: {
    minutesShow: function () {
      switch (true) {
        case parseInt(this.minutesShow) <= 0:
          this.color = "red";
          break;
        case parseInt(this.minutesShow) > 0 && parseInt(this.minutesShow) <= 3:
          this.color = "orange";
          break;
        case parseInt(this.minutesShow) > 3:
          this.color = "green";
          break;
        default:
          break;
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {
    let secondsLeft = this.$appFormatters.getSecondsNow();
    this.minutesShow = this.$appFormatters.formatTimeLeftToNow(this.timeReady);

    let percent = 100 / this.totalMinutes;

    if (this.minutesShow <= 0) {
      this.value = 100;
      this.minutesShow = 0;
    } else {
      this.value = percent * this.minutesShow;
      // this.value = this.value - 100;
      if (parseInt(secondsLeft) > 5) {
        setTimeout(() => {
          this.minutesShow = this.$appFormatters.formatTimeLeftToNow(
            this.timeReady
          );
          if (this.minutesShow <= 0) {
            this.value = 100;
            this.minutesShow = 0;
          } else {
            this.value = percent * this.minutesShow;
            // this.value = 100 - this.value;
          }
          this.getTiming(percent);
        }, (60 - secondsLeft) * 1000);
      } else {
        this.getTiming(percent);
      }
    }
  },
  methods: {
    getTiming: function (percent) {
      const self = this;
      self.interval = setInterval(() => {
        self.minutesShow = self.$appFormatters.formatTimeLeftToNow(
          self.timeReady
        );
        if (self.minutesShow <= 0) {
          self.minutesShow = 0;
          self.value = 100;
          clearInterval(self.interval);
        } else {
          self.value = percent * self.minutesShow;
          self.value = 100 - self.value;
        }
      }, 60000);
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  line-height: 0.9rem !important;
}
</style>
